module.exports = __webpack_public_path__ + "static/img/qj_logo.cd6cfaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qj_logo.png
// module id = oxJX
// module chunks = 15